import { useCallback } from "react";
import { useGetQuery, useLazyGetQuery, usePostMutation } from "slices/api";
import { ACCESS_APPLICATION } from "tagTypes";

export const useAccessDetailBlockQuery = (query = {}) =>
  useGetQuery({
    endpoint: "access-door-detail/block",
    query,
    tags: [],
  });

export const useLazyAccessDetailLocationsQuery = () => {
  const [getLocation, data] = useLazyGetQuery();
  const location = useCallback(
    async (query = {}) =>
      await getLocation(
        {
          endpoint: "access-door-detail/location",
          query,
          tags: [],
        },
        true
      ).unwrap(),
    [getLocation]
  );
  return [location, data];
};

export const useLazyAccessDetailDoorsQuery = () => {
  const [getDoor, data] = useLazyGetQuery();
  const door = useCallback(
    async (query = {}) =>
      await getDoor(
        {
          endpoint: "access-door-detail/door",
          query,
          tags: [],
        },
        true
      ).unwrap(),
    [getDoor]
  );
  return [door, data];
};

export const useLazyAccessDetailUserQuery = () => {
  const [getAccessDetailUser, data] = useLazyGetQuery();
  const user = useCallback(
    async (id, query = {}) =>
      await getAccessDetailUser(
        {
          endpoint: `access-detail/${id}`,
          query,
          tags: [ACCESS_APPLICATION],
        },
        true
      ).unwrap(),
    [getAccessDetailUser]
  );
  return [user, data];
};

export const useLazyGetUtilityTunnelDetailQuery = () => {
  const [utilityTunnelDetails, data] = useLazyGetQuery();
  const accessDetail = async (id, query = {}) =>
    await utilityTunnelDetails(
      {
        endpoint: `/access-detail/${id}`,
        query,
        tags: [ACCESS_APPLICATION],
      },
      true
    ).unwrap();
  return [accessDetail, data];
};

export const useLazyGetIssuanceRoleByDepartmentId = () => {
  const [issuanceRole, data] = useLazyGetQuery();
  const getIssuanceRole = async (id, query = {}) =>
    await issuanceRole(
      {
        endpoint: `/uta-card-issuance-user/managers/${id}`,
        query,
        tags: [],
      },
      true
    ).unwrap();
  return [getIssuanceRole, data];
};


export const usePostRegisterAccessDetailMutation = () => {
  const [registerConsumer, data] = usePostMutation();
  const login = async (payload, query = {}) => {
    return await registerConsumer({
      endpoint: "/employee-contractor",
      query,
      payload: payload || {},
      toastMessage: "Registered successfully",
      tags: [ACCESS_APPLICATION],
    }).unwrap();
  };
  return [login, data];
};

export const usePostAccessCardDetail = () => {
  const [registerAccessDetail, data] = usePostMutation();
  const register = async (payload, query = {}) => {
    return await registerAccessDetail({
      endpoint: "/access-card-detail",
      query,
      payload: payload || {},
      toastMessage: "Registered successfully",
      tags: [ACCESS_APPLICATION],
    }).unwrap();
  };
  return [register, data];
};
